import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Dropdown from 'react-bootstrap/Dropdown';
import { useApi } from "../../api";
import { ICargo, IProfile, IReferral } from "../../interfaces";
import { Utils } from "../../utils";
import { useTranslation } from "react-i18next";
import CopyToClipboard from "react-copy-to-clipboard";
import { useToast } from "@chakra-ui/react";
import { useProjectCode } from "../../hooks/useProjectCode";

export const NavBar = () => {
  const projectCode = useProjectCode()
  const [expand, setExpand] = useState(false)
  const [mounted, setMounted] = useState(false)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const toast = useToast()

  const [profile, setProfile] = useState<IProfile | null>(null);

  const api = useApi(projectCode)

  const fetchReferral = useCallback((profile: IProfile) => {
    api.getReferralCode((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        let p: IProfile = profile;
        const referral: IReferral = cargo.info;
        p.simpleCode = referral.simpleCode;
        p.referralCode = referral.referralCode;
        localStorage.setItem('memberNo', referral.simpleCode);
        setProfile(p);
      }
    })
  }, [api]);

  const fetchProfile = useCallback(() => {
    if (!Utils().isLogin()) {
      setProfile(null);
    } else {
      api.getProfile((cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          fetchReferral(cargo.info);
        }
      })
    }
  }, [api, fetchReferral])

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    if (!Utils().isLogin()) return;
    fetchProfile()
  }, [api, fetchProfile, mounted])

  return (
    <>

      <nav id="navbar" className="navbar navbar-expand-md px-3 px-sm-4 bg-per py-1 py-md-2">
        <img src={require('../../assets/img/star/LOGOrw.png')} alt="" className="rlogo cursor-pointer" onClick={() => {
          navigate(`/store/${projectCode}/home`)
        }} />

        <div className="d-block d-md-none ms-auto me-2 me-sm-2">
          <a className="" href="/web/home#search">
            <img src={require('../../assets/img/nft/search.png')} alt="" className="" style={{ width: '22px' }} />
          </a>
        </div>


        <Dropdown className="order-2 order-md-3 px-0 ml-4" onClick={fetchProfile}>
          <Dropdown.Toggle
            variant="light"
            className="d-flex align-items-center p-0 rounded-full"
          >
            <img src={profile?.avator
              ? Utils().normalizeImagePath(profile.avator, projectCode)
              : require('../../assets/img/nopic.png')}
              alt=""
              className="rlogo cursor-pointer"
              style={{ borderRadius: '50%', width: '36px', height: '36px' }}
            />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="" className="d-flex align-items-center p-3">
              <img src={profile?.avator
              ? Utils().normalizeImagePath(profile.avator, projectCode)
              : require('../../assets/img/nopic.png')} alt="" className="rlogo mr-3" style={{ borderRadius: '50%', width: '46px', height: '46px' }} />
              {
                Utils().isLogin() && <div>
                  <div className="weight-600">{profile?.nickname}</div>
                  <CopyToClipboard text={profile?.simpleCode || ''} onCopy={() => {
                    toast({
                      title: '使用者代碼已複製',
                      description: profile?.simpleCode,
                      position: 'bottom-right',
                      status: 'success',
                      duration: 9000,
                      isClosable: true,
                    })
                  }}>
                    <div className="text-xs text-gray-500">{profile?.simpleCode}</div>
                  </CopyToClipboard>
                </div>
              }
            </Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/wallet`} className="border-up py-2"><span className="material-icons fs-6 mr-2">account_balance_wallet</span>錢包</Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/profile`} className="py-2"><span className="material-icons fs-6 mr-2">settings</span>帳戶設定</Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/referral`} className="py-2"><span className="material-icons fs-6 mr-2">qr_code</span>推薦代碼</Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/team`} className="py-2"><span className="material-icons fs-6 mr-2">groups</span>我的團隊</Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/product-management`} className="py-2"><span className="material-icons fs-6 mr-2">inventory</span>產品管理</Dropdown.Item>
            <Dropdown.Item href="https://nft.star-river.pro/#service" className="border-up d-block d-lg-none py-2"><span className="material-icons fs-6 mr-2">switch_access_shortcut</span>服務特色</Dropdown.Item>
            <Dropdown.Item href="https://nft.star-river.pro/#function" className="d-block d-lg-none py-2"><span className="material-icons fs-6 mr-2">functions</span>平台功能</Dropdown.Item>
            <Dropdown.Item href="https://nft.star-river.pro/#professional" className="d-block d-lg-none py-2"><span className="material-icons fs-6 mr-2">groups</span>執行團隊</Dropdown.Item>
            <Dropdown.Item href="https://nft.star-river.pro/#advisory" className="d-block d-md-none py-2"><span className="material-icons fs-6 mr-2">support_agent</span>開店諮詢</Dropdown.Item>
            <Dropdown.Item href={`/store/${projectCode}/login`} className="border-up py-2"><span className="material-icons fs-6 mr-2">{Utils().isLogin() ? 'login' : 'logout'}</span>{Utils().isLogin() ? t('logout') : t('login')}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* <button className="navbar-toggler order-2 order-lg-3 px-0 ml-4" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={() => {
            setExpand(!expand)
          }}>
          <span className="material-icons-outlined text-white">menu</span>
        </button> */}
        <div className={`collapse navbar-collapse align-items-center flex-grow-0 order-3 order-md-2 ml-auto mt-3 mt-md-0 ${expand ? 'show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav align-items-center mr-auto">
            <li className="nav-item d-none d-md-block pl-3 pe-0 me-0 me-xl-3">
              <a className="" href="/web/home#search">
                <img src={require('../../assets/img/nft/search.png')} alt="" className="" style={{ minWidth: '24px', width: '24px' }} /></a>
            </li>
            <li className="nav-item d-none d-lg-block">
              <a className="nav-link" href="https://nft.star-river.pro/#service">服務特色</a>
            </li>
            <li className="nav-item d-none d-lg-block">
              <a className="nav-link" href="https://nft.star-river.pro/#function">平台功能</a>
            </li>
            <li className="nav-item d-none d-lg-block">
              <a className="nav-link" href="https://nft.star-river.pro/#professional">執行團隊</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="https://nft.star-river.pro/#advisory">開店諮詢</a>
            </li>
            <li className="nav-item my-3 my-md-0">
              <a
                className="btn btn-light bg-white nav-link txt-14 px-3 font-weight-bolder"
                style={{ borderRadius: '50px', color: '#8322ff' }}
                href="/web/mint"
              >
                開始上架 NFT
              </a>
            </li>
          </ul>
        </div>
        <div></div>
      </nav>

    </>
  )
}